import type React from "react";
import { actionsEntries } from "./playgroundEntries/actions";
import { dataDisplayEntries } from "./playgroundEntries/dataDisplay";
import { dateTimeEntries } from "./playgroundEntries/dateTime";
import { designTokenEntries } from "./playgroundEntries/designTokens";
import { feedbackEntries } from "./playgroundEntries/feedback";
import { filtersToolbarEntries } from "./playgroundEntries/filtersToolbar";
import { formControlsEntries } from "./playgroundEntries/formControls";
import { identityIconsEntries } from "./playgroundEntries/identityIcons";
import { loadingEntries } from "./playgroundEntries/loading";
import { overlaysEntries } from "./playgroundEntries/overlays";
import { selectionEntries } from "./playgroundEntries/selection";
import { structureLayoutEntries } from "./playgroundEntries/structureLayout";
import { tablesEntries } from "./playgroundEntries/tables";
import { textFormattingEntries } from "./playgroundEntries/textFormatting";

export const DESIGN_SYSTEM_PATH = "/design-system";

export const designSystemEntryPath = (id: string) =>
    `${DESIGN_SYSTEM_PATH}/${id}`;

export type PlaygroundGroup =
    | "design-tokens"
    | "ready-components"
    | "components";

// oxlint-disable-next-line typescript/array-type
export const playgroundGroups: readonly {
    id: PlaygroundGroup;
    title: string;
}[] = [
    { id: "design-tokens", title: "Design tokens" },
    { id: "ready-components", title: "Ready components" },
    { id: "components", title: "Components" },
];

export interface PlaygroundComponentEntry {
    id: string;
    label: string;
    description: string;
    group: PlaygroundGroup;
    /** `fill`: the entry gets the rest of the viewport and owns its scrolling. */
    layout?: "fill";
    render: () => React.ReactNode;
}

const sortEntriesByLabel = (entries: readonly PlaygroundComponentEntry[]) =>
    [...entries].sort((first, second) =>
        first.label.localeCompare(second.label),
    );

/**
 * Registry of components available in the /design-system. Add an entry
 * here to expose a new component in the left-hand navigation.
 */
export const playgroundComponents: readonly PlaygroundComponentEntry[] = [
    ...sortEntriesByLabel(designTokenEntries),
    ...sortEntriesByLabel([
        ...formControlsEntries,
        ...selectionEntries,
        ...dateTimeEntries,
        ...actionsEntries,
        ...overlaysEntries,
        ...feedbackEntries,
        ...loadingEntries,
        ...textFormattingEntries,
        ...dataDisplayEntries,
        ...tablesEntries,
        ...structureLayoutEntries,
        ...identityIconsEntries,
        ...filtersToolbarEntries,
    ]),
];
